import { Component, OnInit, Input, forwardRef } from '@angular/core';

import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

@Component({

    selector: 'aFormRadio,[aFormRadio]',
    templateUrl: './aFormRadio.component.html',
    styleUrls: ['./aFormRadio.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormRadioComponent, multi: true },
    ]
})
export class AFormRadioComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() disabled;
    @Input() icon;
    @Input() options;
    value;
    temp;
    _onChange = (value: any) => { };
    onChange(value: any) {
        if (value == "") {
            this.value = null;
            this._onChange(null);
        } else {
            this.value = value;
            this._onChange(value);
        }

    };

    getLabel() {
        if (this.value && this.value._id && this.options) {
            let option:Array<any> =this.options.filter(x=> x._id === this.value._id);
            if(option.length >0){
                return option[0].label;
            }
        }
        return "";
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }

    registerOnTouched() { }
    writeValue(value: any) {
        this.value = value;
    }

    constructor(public rootService:RootService) {
        this.temp = "";
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormRadio/aFormRadio.component.ts